<template>
  <div class="title-wrap">
    <div class="left">
      <span class="tit-lf"></span>
      <span class="title-color">{{title}}</span>
    </div>
    <div class="rig">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baseTitle',
  props: {
    title: {
      type: String,
      default: '',
    }
  }
}
</script>

<style lang="less" scoped>
.title-wrap {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  // background: rgb(169, 201, 235);
}
.left {
  display: flex;
  align-items: center;
}
.tit-lf {
  display: inline-block;
  height: 26px;
  width: 5px;
  background: #4c89fc;
  margin-right: 10px;
}
.el-icon-menu {
  color: #4c8afc;
}
.title-wrap .rig {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  padding-right: 6px;
}
</style>